module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-hero.ab0166d2.jpg";